import type { ReactElement } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { DealCardPage } from '../features/deals/pages/DealCardPage.js';

export default function DealDetailPage(): ReactElement {
  const { dealId } = useParams<{ dealId: string }>();

  if (!dealId) {
    return <Navigate to="/deals" replace />;
  }

  return <DealCardPage dealId={dealId} />;
}
